module.exports = __webpack_public_path__ + "static/img/0756.cc0a057.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0756.jpg
// module id = 95
// module chunks = 0